<app-header [ngClass]="{'no-headeer': noHeaderMode == true, 'sample-data-mode-header': sampleDataModeEnabled}" [hidden]="meetMode" style="background-color: white; color: black;"
  [fixed]="true" [navbarBrandRouterLink]="['/home']"
  [navbarBrandMinimized]="{src: 'assets/img/brand/Icon Transparent.png', width: 30, height: 30, alt: 'Superfone'}"
  [sidebarToggler]="false" [asideMenuToggler]="'lg'" [mobileAsideMenuToggler]="true">

  <button type="button" class="btn btn-link d-lg-none px-2 mobile-sidebar-toggler" aria-label="Toggle navigation"
    (click)="toggleMobileSidebar()">
    <mat-icon>menu</mat-icon>
  </button>

  <nav #salesmaxHeader1 class="ml-2 main-toolbar-tabs d-none d-lg-flex align-items-end"
    style="height : 100% !important">
    @for (section of mainSections; track section; let i = $index) {
    <div class="tab-container" [isOpen]="hoveredDropdownIndex === i" dropdown
      [ngClass]="{ 'active': currentMainSection === section.sectionKey }" placement="bottom"
      (mouseenter)="hoveredDropdownIndex = i" (mouseleave)="hoveredDropdownIndex = null">
      @if (!section.isMore) {
      <a routerLink="{{ section.route }}" class="tab-link">
        @if (!hideIcons) {
        <mat-icon class="me-1">{{ section.icon }}</mat-icon>
        }
        {{ section.label }}
      </a>
      }
      @if (section.isMore) {
      <a class="tab-link" style="cursor: pointer;">
        @if (!hideIcons) {
        <mat-icon class="me-1">{{ section.icon }}</mat-icon>
        }
        {{ section.label }}
      </a>
      }
      <ul *dropdownMenu class="dropdown-menu" role="menu">
        @for (opt of contextualMap[section.sectionKey] || []; track opt) {
        <li role="menuitem" style="cursor: pointer;">
          <a class="dropdown-item" (click)="selectContextualTab(opt)">
            {{ opt.label }}
          </a>
        </li>
        }
      </ul>
    </div>
    }
  </nav>

  <ul #salesmaxHeader2 class="nav navbar-nav ml-auto">
    @if (liveVideoCall > 0) {
    <mat-icon (click)="showVideoCalls()" style="color:green; cursor: pointer;" class="mr-3" [matBadge]="liveVideoCall"
      matBadgeColor="warn">video_call</mat-icon>
    }

    @if (walletFeatureEnabled) {
      <div class="wallet-chip d-none d-xl-inline-flex align-items-center mr-2"
        role="button" tabindex="0" aria-label="Open usage wallet"
        [class.wallet-chip--low]="walletAlert !== 'none'"
        [matTooltip]="walletChipTooltip"
        (click)="goToWallet()" (keydown.enter)="goToWallet()">
        <mat-icon class="wallet-chip-icon">
          {{ walletAlert !== 'none' ? 'warning_amber' : 'account_balance_wallet' }}
        </mat-icon>
        <span class="wallet-chip-amount">
          @if (walletBalanceError) { Unavailable } @else { {{ walletCurrencySymbol }}{{ walletBalance }} }
        </span>
        <mat-icon class="wallet-chip-refresh" [class.spinning]="walletRefreshing"
          (click)="refreshWallet($event)" matTooltip="Refresh wallet">refresh</mat-icon>
      </div>
      <!-- Smaller screens: the balance chip is hidden, so keep an equivalent wallet entry. -->
      <button type="button" class="wallet-chip wallet-chip--compact d-inline-flex d-xl-none align-items-center mr-2"
        [class.wallet-chip--low]="walletAlert !== 'none'" aria-label="Open usage wallet"
        [matTooltip]="walletChipTooltip" (click)="goToWallet()">
        <mat-icon class="wallet-chip-icon">
          {{ walletAlert !== 'none' ? 'warning_amber' : 'account_balance_wallet' }}
        </mat-icon>
      </button>
    }

    <a class="btn d-none d-xl-inline get-support-button" style="cursor: pointer;" (click)="openSupport()">
      @if (!canCustomizeWorkspace()) {<span class="mr-1">Get Support</span>} @else {<span class="mr-1">CUSTOMIZE</span>}&nbsp;<i class="bi-box-arrow-up-right ms-1"></i>
    </a>
    <li class="nav-item dropdown d-md-down-none hvr-grow hover-icon">
      <mat-icon style="cursor: pointer; width: 18px; height: 18px;" (click)="showSearchDialog($event)">search</mat-icon>
    </li>
    <li class="nav-item dropdown d-md-down-none" container="body" dropdown #whatsappDropdown="bs-dropdown" placement="bottom">
      <a style="cursor: pointer;" class="nav-link hvr-grow hover-icon" aria-controls="dropdown-chat" dropdownToggle
        (click)="viewWhatsappUnread()">
        <i class="bi bi-whatsapp"></i>@if (totalWhatsappNewCount > 0) {
        <span class="badge badge-pill badge-danger">{{totalWhatsappNewCount}}</span>
        }
      </a>
      <ul id="dropdown-chat" *dropdownMenu
        class="dropdown-menu dropdown-menu-right g-width-450 g-max-width-600 g-mt-17 rounded" role="menu"
        aria-labelledby="button-alignment">
        <div class="media u-header-dropdown-bordered-v1 g-pa-20">
          <div class="d-flex flex-row">
            <div class="d-flex flex-column">
              <h4
                class="d-flex align-self-center text-uppercase g-font-size-default g-letter-spacing-0_5 g-mr-20 g-mb-0">
                {{totalWhatsappNewCount}}&nbsp;
                New Chats</h4>
              <p class="mb-0">{{totalWhatsappUnreadCount}} Unread</p>
            </div>
          </div>
          <div class="media-body align-self-center text-right">
            <a class="g-color-secondary" [routerLink]="['/conversations/inbox']">View All</a>
          </div>
        </div>
        <div class="d-flex flex-column flex-fill" style="max-height: 50vh; overflow-y : hidden;">
          <ng-scrollbar appearance="compact" [autoHeightDisabled]="false" [autoWidthDisabled]="true"
            [sensorDisabled]="false" style="width : 100%">
            <div class="d-flex flex-column" infinite-scroll [infiniteScrollDistance]="scrollDistance"
              [infiniteScrollUpDistance]="scrollUpDistance" [infiniteScrollThrottle]="throttle"
              (scrolled)="onScrollDownChatChannels()" [scrollWindow]="false">
              @for (chat of fetchedChats; track chat) {
              <div
                style="padding-right: 10px; background-color: white; border-bottom : 1px solid; border-bottom-color: #c8ced380; cursor : pointer"
                (click)="goToSelectedChat(chat)">
                <div class="d-flex flex-column p-2">
                  <div class="d-flex flex-row align-items-center">
                    @if (chat.unreadMessageCount != null && chat.unreadMessageCount > 0 && (selectedChat == null ||
                    selectedChat.channelId != chat.channelId)) {
                    <span [matBadge]="chat.unreadMessageCount" matBadgeOverlap="true">
                      <app-profile-image [displayName]="chat.channel?.contact?.name || ''"
                        [seedForColor]="chat.channel?.contactId"
                        classInput="avatar-square g-width-40--md g-height-40--md rounded-circle g-mr-10--sm"></app-profile-image>
                    </span>
                    }
                    @if (!chat.unreadMessageCount || chat.unreadMessageCount == 0 || !(selectedChat == null ||
                    selectedChat.channelId != chat.channelId)) {
                    <app-profile-image [displayName]="chat.channel?.contact?.name || ''"
                      [seedForColor]="chat.channel?.contactId"
                      classInput="avatar-square g-width-40--md g-height-40--md rounded-circle g-mr-10--sm"></app-profile-image>
                    }
                    <div class="d-flex flex-column w-100 ml-3">
                      <div class="d-flex flex-row align-items-center">
                        @if (chat.channel && chat.channel.contact && chat.channel.contact.name) {
                        <h4 style="font-weight: 500;" class="mb-0">{{chat.channel.contact.name |
                          titlecase}}</h4>
                        }
                        @if (chat.participant && chat.participant.name) {
                        <mat-chip-listbox aria-label="Fish selection" class="ml-auto">
                          <mat-chip-option color="primary" class="chat-chip-user" selected>
                            <mat-chip-avatar style="background-color: #c28cd9; color: white;">
                              <app-profile-image [displayName]="chat.participant?.name || ''"
                                [seedForColor]="chat.participant?.id"
                                classInput="chip-avatar-image"></app-profile-image>
                            </mat-chip-avatar>{{chat.participant.name}}</mat-chip-option>
                        </mat-chip-listbox>
                        }
                      </div>
                      <div class="d-flex flex-row">
                        <div class="col-9 p-0">
                          @if (chat.channel && chat.channel.messages && chat.channel.messages.items &&
                          chat.channel.messages.items.length > 0) {
                          <p class="mr-3 mb-0 single-line">
                            @if (chat.channel.messages.items[0].messageCategory == 'external' &&
                            (chat.channel.messages.items[0].isInbound == null ||
                            chat.channel.messages.items[0].isInbound == false) && (chat.lastOutboundMessageId ==
                            chat.channel.messages.items[0].id && !chat.lastOutboundMessageStatus)) {
                            <mat-icon class="message-type-indicator-icon">access_time</mat-icon>
                            }
                            @if (chat.channel.messages.items[0].messageCategory == 'external' &&
                            (chat.channel.messages.items[0].isInbound == null ||
                            chat.channel.messages.items[0].isInbound == false) && (chat.lastOutboundMessageId ==
                            chat.channel.messages.items[0].id && chat.lastOutboundMessageStatus == 'sent')) {
                            <i style="font-size: 18px; color: #68686ee6" class="bi bi-check2"></i>
                            }
                            @if (chat.channel.messages.items[0].messageCategory == 'external' &&
                            (chat.channel.messages.items[0].isInbound == null ||
                            chat.channel.messages.items[0].isInbound == false) && (chat.lastOutboundMessageId ==
                            chat.channel.messages.items[0].id && chat.lastOutboundMessageStatus == 'delivered')) {
                            <i style="font-size: 18px; color: #68686ee6" class="bi bi-check2-all"></i>
                            }
                            @if (chat.channel.messages.items[0].messageCategory == 'external' &&
                            (chat.channel.messages.items[0].isInbound == null ||
                            chat.channel.messages.items[0].isInbound == false) && (chat.lastOutboundMessageId ==
                            chat.channel.messages.items[0].id && chat.lastOutboundMessageStatus == 'read')) {
                            <i style="font-size: 18px; color: #53bdeb" class="bi bi-check2-all"></i>
                            }
                            @if (chat.channel.messages.items[0].media &&
                            chat.channel.messages.items[0].media.fileMimeType &&
                            chat.channel.messages.items[0].media.fileMimeType.startsWith('image')) {
                            <mat-icon class="message-type-indicator-icon"> image</mat-icon>
                            }
                            @if (chat.channel.messages.items[0].media &&
                            chat.channel.messages.items[0].media.fileMimeType &&
                            chat.channel.messages.items[0].media.fileMimeType.startsWith('audio')) {
                            <mat-icon class="message-type-indicator-icon"> record_voice_over</mat-icon>
                            }
                            @if (chat.channel.messages.items[0].media &&
                            chat.channel.messages.items[0].media.fileMimeType &&
                            chat.channel.messages.items[0].media.fileMimeType.startsWith('video')) {
                            <i class="bi bi-camera-video-fill message-type-indicator-icon"></i>
                            }
                            @if (chat.channel.messages.items[0].media &&
                            chat.channel.messages.items[0].media.fileMimeType &&
                            !chat.channel.messages.items[0].media.fileMimeType.startsWith('image') &&
                            !chat.channel.messages.items[0].media.fileMimeType.startsWith('audio') &&
                            !chat.channel.messages.items[0].media.fileMimeType.startsWith('video')) {
                            <mat-icon class="message-type-indicator-icon"> insert_drive_file</mat-icon>
                            }
                            {{chat.channel.messages.items[0].text}}
                          </p>
                          }
                        </div>
                        <div class="col-3 p-0">
                          <div class="d-flex flex-row w-100">
                            @if (chat.isStarred) {
                            <mat-icon class="ml-auto" style="color : #ffc107; font-size : 18px">star</mat-icon>
                            }&nbsp;
                            @if (chat.channel && chat.channel.messages && chat.channel.messages.items &&
                            chat.channel.messages.items.length > 0) {
                            <small [ngClass]="{'ml-auto' : !chat.isStarred}">{{chat.channel.messages.items[0].createdAt
                              | formatDateTime}}</small>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
          </ng-scrollbar>
        </div>
      </ul>
    </li>
    @if (showSampleDataModeControl) {
      <li class="sample-data-mode-control" guideable="trial-sample-data"
        [class.sample-data-mode-control--active]="sampleDataModeEnabled">
        <span class="sample-data-mode-control__name">
          <i class="bi bi-stars" aria-hidden="true"></i>
          <span>Sample data</span>
          @if (sampleDataModeEnabled) {
            <strong>Read-only</strong>
          }
        </span>
        <button type="button" class="sample-data-mode-control__switch" role="switch"
          [attr.aria-checked]="sampleDataModeEnabled" [attr.aria-label]="sampleDataModeEnabled ? 'Turn off sample data' : 'Turn on sample data'"
          [title]="sampleDataModeEnabled ? 'Return to your real workspace data' : 'Preview sample leads in the real Leads screen'"
          (click)="toggleSampleDataMode($event)">
          <span class="sample-data-mode-control__track" aria-hidden="true">
            <span class="sample-data-mode-control__thumb"></span>
          </span>
          <span class="sample-data-mode-control__state">{{ sampleDataModeEnabled ? 'On' : 'Off' }}</span>
        </button>
      </li>
    }
    <li class="nav-item" style="cursor: pointer;" (click)="openUserActions()">
      <!-- Top User -->
      <div class="col-auto d-flex g-pt-5 g-pt-0--sm g-pl-10 g-pl-20--sm px-0">
        <div class="g-pos-rel">
          @if (activeAccount) {
          <a #workspaceIndicator style="cursor: pointer;" class="nav-link hvr-grow workspace-indicator" role="button"
            [class.workspace-indicator--confirmed]="workspaceIndicatorHighlighted">
            <div class="d-flex align-items-center">
              <span class="g-pos-rel">
                <span class="u-badge-v2--xs u-badge--top-right g-hidden-sm-up g-bg-secondary g-mr-5"></span>
                @if (activeAccount.account && activeAccount.account.accountType != 'INDIVIDUAL') {
                <app-profile-image [displayName]="activeAccount.account.accountName"
                  defaultImage="assets/img/avatars/organization-default.png"
                  classInput="avatar-square g-width-30 g-width-40--md g-height-30 g-height-40--md rounded-circle g-mr-10--sm"
                  [imageFilePath]="activeAccount.account.businessLogoUrl"></app-profile-image>
                }
                @if (activeAccount.account && activeAccount.account.accountType == 'INDIVIDUAL') {
                <app-profile-image [displayName]="activeAccount.account.accountName"
                  classInput="avatar-square g-width-30 g-width-40--md g-height-30 g-height-40--md rounded-circle g-mr-10--sm"
                  [imageFilePath]="registeredUser.profilePictureUrl"></app-profile-image>
                }
              </span>
              <span class="g-pos-rel d-none d-lg-inline g-top-2 g-pos-rel g-top-2">
                <span [matTooltip]="activeAccount.account.accountName" class="g-hidden-sm-down workspace-indicator__name"
                  [title]="activeAccount.account.accountName"
                  style="font-size: medium; font-weight: 400; color: #5470c6;">
                  {{ activeAccount.account.accountName | titlecase }}
                </span>
                <i class="fa fa-caret-down g-pos-rel g-top-2 g-ml-10"></i>

              </span>
            </div>
          </a>
          }
        </div>
      </div>
      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
        <div class="list-group" style="max-height: 40vh; overflow: hidden;">
          <ng-scrollbar appearance="compact" [autoHeightDisabled]="false" [autoWidthDisabled]="false"
            [sensorDisabled]="true">
            @for (item of dropdownToChooseAccount; track item) {
            <li>
              <div class="d-flex flex-column">
                <a class="dropdown-item hover-icon" style="cursor: pointer;" (click)="changeActiveAccount(item)">
                  {{item.account.accountName | titlecase}}&nbsp;
                  <span class="badge badge-success ng-star-inserted">{{item.account.accountType | formatEnum}}</span>
                </a>
                <!-- <div class="d-flex justify-content-between flex-row" *ngIf="item.userAccountStatus == 'APPROVED'">
                        <a class="btn btn-sm btn-primary hvr-grow" style="cursor: pointer;"
                        (click)="updateMembership(item); openModal(templateAcceptTeamMembership)">Accept</a>
                        <a class="btn btn-sm btn-success hvr-grow" style="cursor: pointer;"
                        (click)="rejectMembership(item)">Reject</a>
                      </div> -->
              </div>
            </li>
            }
            </ng-scrollbar>
            </div>
            @if (activeAccount && activeAccount.authorizationLevel != 'MEMBER') {
            <a class="dropdown-item hvr-grow hover-icon" style="cursor: pointer;" (click)="createOrganzationButtonClicked()"><i
                class="fa fa-plus"></i>&nbsp;New
              Workspace</a>
            }
            @if (activeAccount && activeAccount.authorizationLevel != 'MEMBER') {
            <a class="dropdown-item hvr-grow hover-icon" style="cursor: pointer; background-color: #f2def5;"
              (click)="addMemberButtonClicked()"><i class="fa fa-user"></i>&nbsp;Invite Colleague</a>
            }

            <a class="dropdown-item hvr-grow hover-icon" style="cursor: pointer;" [routerLink]="['/account/manage-account']"><i
                class="fa fa-cog"></i>&nbsp;Manage
              Memberships</a>
            <a class="dropdown-item hvr-grow hover-icon"
              [routerLink]="['/account/profile', {outlets: {'profile': ['profile-detail']}}]"><i class="fa fa-user"></i> Profile
              & Preferences</a>
            <div class="divider"></div>
            <!-- <a class="dropdown-item hvr-grow"><i class="fa fa-handshake-o"></i> Refer Us</a>
          <div class="divider"></div> -->
            <a class="dropdown-item hvr-grow hover-icon" routerLink='/sign-out' routerLinkActive="active"><i
                class="fa fa-sign-out" aria-hidden="true"></i> Sign Out</a>
    </div>
    </li>
    <li class="mx-1" style="color: gray; cursor: pointer;" (click)="toggleAsideMenu()">
      <mat-icon>{{ isAsideOpen ? 'close' : 'apps' }}</mat-icon>
    </li>
  </ul>
  @if ((newMentionCount + newTaskCount + newActivityCount + newPendingAssignmentCount) > 0) {
  <div class="blob green u-badge--top-right" style="position: absolute; right: 5px !important; top: 5px !important;">
  </div>
  }
</app-header>

@if (workspaceConfirmationVisible) {
  <div class="workspace-confirmation-layer"
    [class.workspace-confirmation-layer--merging]="workspaceConfirmationMerging">
    <div class="workspace-confirmation-backdrop" aria-hidden="true"></div>
    <div #workspaceConfirmationCard
      class="workspace-confirmation"
      [class.workspace-confirmation--merging]="workspaceConfirmationMerging"
      [style.--workspace-confirmation-x]="workspaceConfirmationTranslateX"
      [style.--workspace-confirmation-y]="workspaceConfirmationTranslateY"
      [style.--workspace-confirmation-scale]="workspaceConfirmationScale"
      role="status"
      aria-live="polite"
      aria-atomic="true">
      <span class="workspace-confirmation__icon" aria-hidden="true">
        <mat-icon>check</mat-icon>
      </span>
      <span class="workspace-confirmation__copy">
        <span class="workspace-confirmation__label">{{ workspaceConfirmationLabel }}</span>
        <strong class="workspace-confirmation__name">{{ workspaceConfirmationAccountName }}</strong>
      </span>
    </div>
  </div>
}

<!-- Secondary Action Bar -->
@if (contextualOptions.length > 0) {
<div class="contextual-toolbar mat-elevation-z2 d-none d-lg-flex align-items-center justify-content-between px-3 py-2"
  [class.contextual-toolbar--sample]="sampleDataModeEnabled">
  <nav class="contextual-toolbar d-flex align-items-center gap-3 px-4 ml-3">
    @for (option of contextualOptions; track option.label ?? i; let i = $index) {
    <button type="button" (click)="selectContextualTab(option)" class="context-btn"
      [ngClass]="{'active': selectedContextTab === option?.label}"
      [attr.aria-current]="selectedContextTab === option?.label ? 'page' : null">
      {{ option.label }}
    </button>
    }
    @if (activeAccount && (activeAccount?.authorizationLevel == 'SUPERADMIN' || activeAccount?.authorizationLevel ==
    'ADMIN') && currentMainSection == 'dashboard') {
    <button type="button" (click)="openChartGallery()" matTooltip="Charts Library" aria-label="Charts Library" class="context-btn"
      style="font-size: large;"><mat-icon style="color: white" class="me-1" aria-hidden="true">insights</mat-icon>
    </button>
    }
  </nav>
  <div class="d-flex flex-row ml-auto align-items-center">
    @if (onDashboard || onGettingStarted || (daysRemainingInTrial != null && daysRemainingInTrial <= 3)) { <div
      class="mr-2" style="z-index : 101;">
      <div class="d-flex flex-row align-items-center">
        <!-- <ng-container *ngIf="!(daysRemainingInTrial != null && daysRemainingInTrial <= 3)">
          <h2 #salesmaxHeader4 [ngClass]="{'d-none': hideWelcomeMessage}" class="mb-0 p-1 color-background py-1 px-2"
            style="border-radius: 5px;" *ngIf="onDashboard">Hi {{activeAccount?.user?.name | titlecase}}!! You are in
            {{activeAccount?.account?.accountName | titlecase}}&nbsp;<span
          *ngIf="activeAccount && activeAccount.account && activeAccount.account.accountType != 'TEAM'">(Trial)&nbsp;</span>Workspace
        </h2>
        <h2 #salesmaxHeader6 [ngClass]="{'d-none': hideWelcomeMessage}" class="mb-0 p-1 color-background py-1 px-2"
          style="border-radius: 5px;" *ngIf="onGettingStarted">Hi {{activeAccount?.user?.name | titlecase}}!! You
          are in {{activeAccount?.account?.accountName | titlecase}}&nbsp;<span
        *ngIf="activeAccount && activeAccount.account && activeAccount.account.accountType != 'TEAM'">(Trial)&nbsp;</span>Workspace.
      Let's Get Started!!!</h2>
    </ng-container>&nbsp;
    <ng-container *ngIf="daysRemainingInTrial != null && daysRemainingInTrial <= 3">
      <h2 #salesmaxHeader5 [ngClass]="{'d-none': hideWelcomeMessage}" class="mb-0 p-1 color-background py-1 px-2"
        style="border-radius: 5px;">Your Trial is getting over in <strong>&nbsp;{{daysRemainingInTrial}}
      Days</strong></h2>&nbsp;&nbsp;
    </ng-container> -->
        @if (onDashboard && !onGettingStarted) {
        <li class="nav-item dropdown" container="body" dropdown #dashFilterDropdown="bs-dropdown" placement="bottom right">
          <a class="d-flex align-items-center" style="cursor: pointer; gap: 6px;" dropdownToggle (click)="false"
            [attr.aria-label]="'Dashboard filters, period: ' + selectedPeriodText">
            <span class="d-none d-xl-inline" style="font-size: 13px; font-weight: 500;">{{selectedPeriodText}}</span>
            @if (activeAccount && activeAccount.authorizationLevel != 'MEMBER') {
              @if (selectedUser?.length > 0 || selectedTeam?.length > 0 || selectedTeamMember?.length > 0) {
                <span class="badge badge-pill" style="background: #f62d51; color: #fff; font-size: 10px;">
                  @if (selectedUser?.length > 0) { {{selectedUser.length}} User{{selectedUser.length > 1 ? 's' : ''}} }
                  @if (selectedTeam?.length > 0) { {{selectedTeam.length}} Team{{selectedTeam.length > 1 ? 's' : ''}} }
                  @if (selectedTeamMember?.length > 0) { + {{selectedTeamMember.length}} Member{{selectedTeamMember.length > 1 ? 's' : ''}} }
                </span>
              }
            }
            <i class="bi bi-funnel" style="font-size: 14px;"></i>
          </a>

          <div *dropdownMenu class="dropdown-menu dropdown-menu-right rounded shadow-lg p-0"
            style="min-width: 340px; max-width: 400px; border: 1px solid #e2e8f0;" role="menu"
            (click)="$event.stopPropagation()">

            <!-- Header -->
            <div class="d-flex align-items-center justify-content-between px-3 py-2" style="border-bottom: 1px solid #e2e8f0; background: #f8fafc;">
              <span style="font-weight: 600; font-size: 13px; color: #1e293b;">Dashboard Filters</span>
              @if (selectedUser?.length > 0 || selectedTeam?.length > 0 || selectedTeamMember?.length > 0) {
                <a style="font-size: 12px; color: #3b82f6; cursor: pointer;" (click)="removeTopFilter('user'); removeTopFilter('team');">Clear All</a>
              }
            </div>

            <!-- Period chips -->
            <div class="px-3 pt-3 pb-2">
              <div style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; color: #64748b; font-weight: 600; margin-bottom: 6px;">Time Period</div>
              <div class="d-flex flex-wrap" style="gap: 4px;">
                @for (period of allPeriods; track period) {
                  <span class="period-chip" [class.period-chip--active]="selectedPeriod === period.value"
                    (click)="selectPeriod(period)" style="cursor: pointer;">
                    {{period.viewValue}}
                  </span>
                }
              </div>
            </div>

            <!-- Scope selectors -->
            @if (activeAccount && activeAccount.authorizationLevel != 'MEMBER') {
              <div class="px-3 pb-3" style="border-top: 1px solid #f1f5f9;">

                <!-- User selector -->
                @if (activeAccount.authorizationLevel != 'MANAGER' && allUsers && allUsers.length > 0) {
                  <div class="mt-2">
                    <div style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; color: #64748b; font-weight: 600; margin-bottom: 6px;">Users</div>
                    <ng-select class="filter-panel-select" #userSelect [items]="allUsers" [selectOnTab]="true"
                      [(ngModel)]="selectedUser" [clearable]="true" bindLabel="user.name" multiple="true"
                      (change)="onUserSelectChange($event)" placeholder="Select users...">
                      <ng-template ng-label-tmp let-item="item">
                        <div class="d-flex align-items-center" style="gap: 4px;">
                          <app-profile-image classInput="avatar-square-small" [displayName]="item.user?.name"
                            [imageFilePath]="item.user?.profilePictureUrl">
                          </app-profile-image>
                          <span style="font-size: 12px;">{{item.user?.name | titlecase}}</span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="d-flex align-items-center py-1" style="gap: 8px;">
                          <app-profile-image classInput="avatar-square-small" [displayName]="item.user?.name"
                            [imageFilePath]="item.user?.profilePictureUrl">
                          </app-profile-image>
                          <div class="d-flex flex-column" style="min-width: 0;">
                            <span style="font-size: 13px; font-weight: 500;">{{item.user?.name | titlecase}}</span>
                            <span style="font-size: 11px; color: #94a3b8;">{{item.authorizationLevel | titlecase}}</span>
                          </div>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                }

                <!-- Team selector -->
                @if ((activeAccount.authorizationLevel == 'SUPERADMIN' || activeAccount.authorizationLevel == 'ADMIN') && fetchedTeams && fetchedTeams.length > 0) {
                  <div class="mt-2">
                    <div style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; color: #64748b; font-weight: 600; margin-bottom: 6px;">Teams</div>
                    <ng-select class="filter-panel-select" #teamSelect [items]="fetchedTeams" [selectOnTab]="true"
                      [(ngModel)]="selectedTeam" multiple="true" [clearable]="true"
                      bindLabel="teamName" (change)="onTeamSelectChange($event)" placeholder="Select teams...">
                    </ng-select>
                  </div>
                }
                @if (activeAccount.authorizationLevel == 'MANAGER' && directTeamsAsTL && directTeamsAsTL.length > 0) {
                  <div class="mt-2">
                    <div style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; color: #64748b; font-weight: 600; margin-bottom: 6px;">Teams</div>
                    <ng-select class="filter-panel-select" #teamSelect [items]="directTeamsAsTL" [selectOnTab]="true"
                      [(ngModel)]="selectedTeam" multiple="true" [clearable]="false" bindLabel="teamName"
                      (change)="onTeamSelectChange($event)" placeholder="Select teams...">
                    </ng-select>
                  </div>
                }

                <!-- Team member selector (only when teams selected) -->
                @if (selectedTeam.length > 0 && selectedTeamMembers && selectedTeamMembers.length > 0) {
                  <div class="mt-2">
                    <div style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; color: #64748b; font-weight: 600; margin-bottom: 6px;">Team Members</div>
                    <ng-select class="filter-panel-select" #teamMemberSelect [items]="selectedTeamMembers"
                      [selectOnTab]="true" [(ngModel)]="selectedTeamMember" [clearable]="true" multiple="true"
                      bindLabel="user.name" (change)="onTeamMemberSelectChange($event)" placeholder="Select members...">
                    </ng-select>
                  </div>
                }
              </div>
            }
          </div>
        </li>
        }
        @if (onDashboard && !onGettingStarted && authorizationLevel && authorizationLevel != 'MEDMBER' &&
        authorizationLevel != 'MANAGER') {
        <a [routerLink]="['/home/get-started']"><mat-icon style="color: #f62d51">info</mat-icon></a>
        }
      </div>
  </div>
  }
  @if (currentMainSection == 'leads' && !sampleDataModeEnabled) {
  <div class="mr-2" style="z-index : 101;">
    <button type="button" class="contextual-outline-button float-right fs-xxl-inline hvr-grow"
      (click)="goToNewBulkUpload()">+ New Upload</button>
  </div>
  }
  @if (currentMainSection != '') {
  <i (click)="refreshData($event)" (keydown.enter)="refreshData($event)" class="fa fa-refresh contextual-toolbar-icon material-icons mx-2"
    matTooltip="Reload and refresh data" style="cursor: pointer;" role="button" tabindex="0" aria-label="Reload and refresh data"></i>
  }
  @if (!sampleDataModeEnabled) {
    <i class="contextual-toolbar-icon material-icons mx-2" (click)="openAdHocTask()" (keydown.enter)="openAdHocTask()"
      matTooltip="Add Task / Reminder" role="button" tabindex="0" aria-label="Add Task / Reminder">add</i>
  }
<i class="contextual-toolbar-icon material-icons mx-2" guideable="trial-support-chat" (click)="openSupportChat()" (keydown.enter)="openSupportChat()"
    matTooltip="Support Chat" role="button" tabindex="0" aria-label="Support Chat">support_agent</i>
</div>
</div>
}
<div class="app-body"
  [ngClass]="{'fill-height-box': applyCustomCssClass, 'fill-height-box-x-scroll' : applyCustomCssClassXscroll, 'fill-height-box-no-header' : noHeaderMode, 'app-body-95' : currentMainSection != '', 'app-body-55' : currentMainSection == '', 'meet-mode-body': meetMode}">

  <!-- Mobile sidebar - deferred since it's hidden on desktop (d-lg-none) -->
  @if (!meetMode) {
    @defer (on idle) {
      <app-sidebar class="d-lg-none" [ngClass]="{'full-height-sidebar': noHeaderMode == true}" [fixed]="true"
        [display]="'lg'">
        <app-sidebar-nav [navItems]="navItems" [perfectScrollbar] [disabled]="sidebarMinimized"
          [ngClass]="{'sidebarMinimizedState': sidebarMinimized}"></app-sidebar-nav>
        <app-sidebar-footer>
        </app-sidebar-footer>
        <app-sidebar-minimizer></app-sidebar-minimizer>
      </app-sidebar>
    }
  }

  <!-- Main content -->
  <main class="main">
    @if (accountBootstrapFailed && !activeAccount) {
    <section class="account-bootstrap-recovery" role="alert" aria-live="assertive">
      <div class="account-bootstrap-recovery__card">
        <div class="account-bootstrap-recovery__icon" aria-hidden="true">
          <mat-icon>domain_disabled</mat-icon>
        </div>
        <h1>We couldn't load your workspace</h1>
        <p>{{ accountBootstrapError }}</p>
        <div class="account-bootstrap-recovery__actions">
          <button mat-raised-button color="primary" type="button"
            [disabled]="accountBootstrapRetrying" (click)="retryAccountBootstrap()">
            <mat-icon>refresh</mat-icon>
            {{ accountBootstrapRetrying ? 'Trying again...' : 'Try again' }}
          </button>
          <button mat-stroked-button type="button"
            [disabled]="accountBootstrapRetrying" (click)="signOutFromAccountBootstrap()">
            <mat-icon>logout</mat-icon>
            Sign out
          </button>
        </div>
      </div>
    </section>
    }
    <!-- <div *ngIf="loaderService.isLoading | async" class="loader-container">
    <mat-progress-bar *ngIf="!applyCustomCssClass" mode="indeterminate"></mat-progress-bar>
  </div> -->
    <!-- <alert type="danger"
  *ngIf="daysRemainingInTrial != null && daysRemainingInTrial <= 3 && activeAccount.authorizationLevel == 'SUPERADMIN'">
  <div class="d-flex justify-content-center align-items-center">
    <p style="margin: 0px" *ngIf="daysRemainingInTrial != null && daysRemainingInTrial > 0">Your Trial is getting
      over in <strong>&nbsp;{{daysRemainingInTrial}} Days</strong>&nbsp;&nbsp;</p>
      <p style="margin: 0px" *ngIf="daysRemainingInTrial != null && daysRemainingInTrial <= 0"><strong>Your Trial Got
      Over</strong>&nbsp;&nbsp;</p>
      <div class="btn-group" role="group" aria-label="Basic example">
        <button type="button" (click)="trialExpiredAction()" class="btn btn-success">Take Action</button>
      </div>
    </div>
  </alert> -->
    @if (onDashboard && activeAccount?.account?.lastPaymentDataId != null && ((daysOverPaidFor && daysOverPaidFor >= -3)
    || (daysOverPaidForBasedOnDue && daysOverPaidForBasedOnDue >= -3))) {
    <alert type="danger" style="cursor: pointer;" (click)="goToPaymentPage()">
      <div class="d-flex flex-row" style="font-weight: bolder; color: red;">
        Payment Pending : Your account is due for payment. Please make payment asap to ensure uninterrupted access to
        Salesmax.
      </div>
    </alert>
    }
    @if (accountsInNeedOfAcceptance && accountsInNeedOfAcceptance.length == 1) {
    <alert type="danger">
      <div class="d-flex flex-row">
        You have been invited to account &nbsp;<strong>{{accountsInNeedOfAcceptance[0].account.accountName |
          titlecase}}</strong>&nbsp;by&nbsp;<strong>{{accountsInNeedOfAcceptance[0].addedBy.name | titlecase}}</strong>
        <div class="btn-group ml-auto" role="group" aria-label="Basic example">
          <button type="button" class="btn btn-secondary"
            (click)="rejectMembership(accountsInNeedOfAcceptance[0])">Reject</button>
          <button type="button" class="btn btn-success"
            (click)="acceptMembership(accountsInNeedOfAcceptance[0])">Accept</button>
        </div>
      </div>
    </alert>
    }
    @if (accountsInNeedOfNumberChangeApproval && accountsInNeedOfNumberChangeApproval.length > 0) {
    <alert type="danger">
      @for (member of accountsInNeedOfNumberChangeApproval; track member) {
      <div class="d-flex flex-colum mb-1">
        <div class="d-flex flex-row w-100 align-items-center">
          User {{member?.user?.name || ''}} has changed registered number. Approve to allow him/her back into workspace.
          <div class="btn-group ml-auto" role="group" aria-label="Basic example">
            <!-- <button type="button" class="btn btn-secondary"
            (click)="rejectMembership(accountsInNeedOfAcceptance[0])">Reject</button> -->
            <button type="button" class="btn btn-success" (click)="approveNumberChange(member)">Approve</button>
          </div>
        </div>
      </div>
      }
    </alert>
    }
    @if (!isOnline) {
    <alert type="danger">
      <div class="d-flex justify-content-center">
        You Seem To Be Offline
      </div>
    </alert>
    }
    @if (isOnline && reconnectReloadRequired) {
    <alert type="info">
      <div class="d-flex flex-wrap align-items-center justify-content-between" role="status">
        <span>Connection restored. Save any unfinished work, then reload to sync data.</span>
        <button type="button" class="btn btn-sm btn-outline-primary ml-2" (click)="reloadAfterReconnect()">Reload to sync</button>
      </div>
    </alert>
    }
    @if (showHealthBanner && onDashboard) {
    <alert type="warning">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center" style="gap: 8px;">
          <strong>Daily App Health Check:</strong>
          <span>{{healthBannerIssueCount}} {{healthBannerIssueCount === 1 ? 'user needs' : 'users need'}} attention</span>
          <span class="text-muted" style="font-size: 0.85em;">· hides in {{healthBannerCountdown}}s</span>
        </div>
        <div class="d-flex align-items-center" style="gap: 8px;">
          <button class="btn btn-sm btn-warning" (click)="goToAppHealth()">Review Now</button>
          <button class="btn btn-sm btn-outline-secondary" (click)="dismissHealthBanner()">Later Today</button>
        </div>
      </div>
    </alert>
    }
    <!-- deprecation warning for 'app-breadcrumb' -->
    <!-- <ol class="breadcrumb">
<app-breadcrumb></app-breadcrumb>
<li class="breadcrumb-menu d-md-down-none">
  <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
    <a class="btn" href="#"><i class="icon-speech"></i></a>
    <a class="btn" [routerLink]="['/home']"><i class="icon-graph"></i> &nbsp;Dashboard</a>
    <a class="btn" href="#"><i class="icon-settings"></i> &nbsp;Settings</a>
  </div>
</li>
</ol> -->
    <div #salesmaxHeader class="container-fluid" style="padding: 0 5px !important; margin-top: 5px;"
      [ngClass]="{'full-mode': noHeaderMode == true}">
      @if (!sampleDataModeEnabled || isCurrentRouteSampleDataSupported) {
      <router-outlet></router-outlet>
      } @else {
      <section class="sample-data-unavailable" role="status" aria-live="polite">
        <span class="sample-data-unavailable__icon" aria-hidden="true"><i class="bi bi-stars"></i></span>
        <h1>Sample data is not available on this page</h1>
        <p>This page is still available with your real workspace data. Turn off sample data to continue here.</p>
        <button type="button" class="btn btn-primary" (click)="exitSampleDataMode($event)">
          Use real workspace data
        </button>
      </section>
      }
    </div><!-- /.container-fluid -->
  </main>
  <div class="aside-drawer" [class.open]="isAsideOpen">
  @defer (when isAsideOpen; prefetch on idle) {
  <app-aside [fixed]="true" [display]="false" [ngClass]="'test'" style="height: 100%;">
    <tabset>
      <tab (selectTab)="onSelect('status')">
        <ng-template tabHeading>
          <div class="avatar2">
            <i class="fa fa-info-circle"></i>
            <span class="avatar-status2 g-bg-secondary"></span>
          </div>
        </ng-template>
        <div class="comment-box" style="margin-bottom: 0px !important;"> User Status </div>
        <form class="form-inline my-2 my-lg-0">
          <input class="form-control" style="width : 100%" name="quickUserSearch" type="search"
            [(ngModel)]="userNameSearchValue" placeholder="Search By Name" aria-label="Search">
        </form>
        @for (status of allMemberStatusData | userClientfilter:userNameSearchValue; track status.userId ?? status.id ?? status.name) {
        <div class="d-flex flex-row mt-2 mb-2 mr-2 ml-2" style="border-bottom: 1px solid rgba(0,0,0,.125);">
          <div class="d-flex flex-column" style="width: 100%">
            <div class="d-flex flex-row" style="width: 100%">
              <div class="d-flex align-items-center">
                <div class="mr-1 float-left">
                  <div class="avatar-small">
                    <app-profile-image classInput="avatar-square-small" [displayName]="status.name"
                      [imageFilePath]="status.userProfilePic">
                    </app-profile-image>
                  </div>
                </div>&nbsp;
                <div>
                  <small class="text-muted">{{ status.name }}</small>
                </div>
              </div>
              @if ((status.lastActivityTimeStamp !=null) && (currentTime < (status.lastActivityTimeStamp + 900000))) {
                <span class="badge badge-light-success fw-bold me-1 ml-auto">Active</span>
                }
                @if ((status.lastActivityTimeStamp == null) || (currentTime > (status.lastActivityTimeStamp + 900000)))
                {
                <span class="badge badge-light-danger fw-bold me-1 ml-auto">Inactive</span>
                }
            </div>
            @if (status.lastActivityBody && status.lastActivityBody != '--') {
            <div class="small text-muted">
              <span>{{status.lastActivityType | formatEnum}}&nbsp;|&nbsp;{{status.lastActivityTime | formatDateRealTime:
                currentTime}}</span>
            </div>
            }
          </div>
        </div>
        }
      </tab>
      <tab (selectTab)="onSelect('fresh')">
        <ng-template tabHeading>
          <div class="avatar2">
            <i class="bi bi-person-square"></i>
          </div>
        </ng-template>
        <div class="comment-box" style="margin-bottom: 0px !important;"> Today's New Leads </div>
        <ul class="list-unstyled">
          @for (lead of freshLeads; track lead) {
          <li class="d-flex justify-content-start g-brd-around g-brd-gray-light-v4 p-2">
            <div class="g-pos-rel g-mr-5">
              <!-- <app-profile-image classInput="g-width-30 g-height-30 rounded-circle"
              [imageFilePath]="lead.profilePhotoUrl"></app-profile-image> -->
            </div>
            <div class="align-self-center g-px-10">
              <a [routerLink]="['/leads/lead-detail', lead.id]">
                <h5 class="h6 g-font-weight-600 g-color-black g-mb-3">
                  <span class="g-mr-5">{{lead.name | titlecase}}</span>
                  <small class="g-color-blue">{{lead.contactType | formatEnum}}</small>
                </h5>
              </a>
              <small class="m-0">@if (lead.designation) {
                <span>Designation :
                  {{lead.designation}} </span>
                }
                @if (lead.accountPriority) {
                <span>&nbsp;Priority:
                  {{lead.accountPriority | formatEnum}} </span>
                }
                @if (lead.contactSource) {
                <span>&nbsp;Source:
                  {{lead.contactSource}} </span>
                }
                @if (lead.contactNumberDetail && lead.contactNumberDetail.length > 0) {
                <span>
                  Number :
                  {{lead.contactNumberDetail[0].phoneNumber}}</span>
                }
              </small>
            </div>
            <div class="align-self-center ml-auto">
              <small>{{lead.createdAt | formatDate}}</small>
            </div>
          </li>
          }
        </ul>
      </tab>
      <tab (selectTab)="onSelect('task')">
        <ng-template tabHeading>
          <div class="avatar2">
            <i class="fa fa-tasks" aria-hidden="true"></i>
            @if (newTaskCount > 0) {
            <span class="avatar-status2 g-bg-secondary"></span>
            }
          </div>
        </ng-template>
        <div class="comment-box" style="margin-bottom: 0px !important;"> Recent Tasks </div>
        <div class="list-group list-group-accent">
          <div
            class="list-group-item list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small">
            Today</div>
          @if (myTasksDueToday.length == 0) {
          <alert type="success">
            All Caught Up!!! No Task scheduled for today<br />
            <button mat-raised-button (click)="goToCreateTask()">Create</button>
          </alert>
          }
          @if (myTasksDueToday.length > 0) {
          <div style="padding-left: 0px;">
            <perfect-scrollbar style="max-height: 50vh;" class="ps-show-always" fxFlex="auto">
              <div>
                @for (task of myTasksDueToday; track trackById) {
                <div class="list-group-item list-group-item-accent-warning list-group-item-divider"
                  [ngClass]="{'new-rows': (task && task.isRealTime)}">
                  <div class="avatar float-right">
                    @if (task.addedBy) {
                    <app-profile-image classInput="avatar-square" [displayName]="task.addedBy.name"
                      [imageFilePath]="task.addedBy.profilePictureUrl"></app-profile-image>
                    }
                  </div>
                  <div><strong>{{task.taskHeading}}</strong></div>
                  <small class="text-muted mr-3">
                    @if (task.dueDateTime) {
                    <i class="icon-calendar"></i>
                    }&nbsp;{{task.dueDateTime | formatDate
                    }}</small>
                  @if (task.taskLocation && task.taskLocation.city) {
                  <small class="text-muted">
                    <i class="icon-location-pin"></i>&nbsp;{{task.taskLocation.city}}</small>
                  }
                </div>
                }
              </div>
            </perfect-scrollbar>
          </div>
          }
          <div
            class="list-group-item list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small">
            Overdue</div>
          @if (myTasksOverdue.length == 0) {
          <alert type="success">
            No Overdue Tasks!!!
          </alert>
          }
          @if (myTasksOverdue.length > 0) {
          <div style="padding-left: 0px;">
            <perfect-scrollbar style="max-height: 50vh;" class="ps-show-always" fxFlex="auto">
              <div>
                @for (task of myTasksOverdue; track task.id) {
                <div class="list-group-item list-group-item-accent-warning list-group-item-divider">
                  <div class="avatar float-right">
                    @if (task.addedBy) {
                    <app-profile-image classInput="avatar-square" [displayName]="task.addedBy.name"
                      [imageFilePath]="task.addedBy.profilePictureUrl"></app-profile-image>
                    }
                  </div>
                  <div><strong>{{task.taskHeading}}</strong></div>
                  <small class="text-muted mr-3">
                    @if (task.dueDateTime) {
                    <i class="icon-calendar"></i>
                    }&nbsp;{{task.dueDateTime | formatDate
                    }}</small>
                  @if (task.taskLocation && task.taskLocation.city) {
                  <small class="text-muted">
                    <i class="icon-location-pin"></i>&nbsp;{{task.taskLocation.city}}</small>
                  }
                </div>
                }
              </div>
            </perfect-scrollbar>
          </div>
          }
        </div>
      </tab>
      <tab (selectTab)="onSelect('activity')" b>
        <ng-template tabHeading>
          <div class="avatar2">
            <i class="fa fa-signal" aria-hidden="true"></i>
            @if (newActivityCount > 0) {
            <span class="avatar-status2 g-bg-secondary"></span>
            }
          </div>
        </ng-template>
        <div class="comment-box" style="margin-bottom: 0px !important;"> Recent Activities </div>
        @for (activity of recentActivities; track trackById) {
        <div class="d-flex flex-row mt-2 mb-2 mr-2 ml-2" style="border-bottom: 1px solid rgba(0,0,0,.125);">
          <!-- <div class="pl-1 mr-3 float-left">
                <div class="avatar">
                  <app-profile-image *ngIf="activity.user" classInput="avatar-square" [displayName]="activity.user.name"
                  [imageFilePath]="activity.user.profilePictureUrl"></app-profile-image>
                  <span class="avatar-status g-bg-secondary"></span>
                </div>
              </div> -->
          <div class="d-flex flex-column w-100">
            <a>
              <div class="d-flex flex-row justify-content-between">
                <span class="badge badge-light-info fw-bold me-1" style="font-size: small;"><small
                    class="text-muted">{{activity.activityType |
                    formatEnum}}</small></span>
                @if (activity.createdAt) {
                <small style="font-weight: bold;" class="text-muted float-right mt-1 ml-auto">{{activity.createdAt |
                  formatDate}}</small>
                }
              </div>
              <small class="text-muted">{{activity.body}}</small>
            </a>
            @if (activity.contactId !=null && activity.contact !=null) {
            <a [routerLink]="['/leads/lead-detail', activity.contact.id]" class="p-1 d-flex flex-row mr-auto">
              <div class="d-flex align-items-center">
                <div class="mr-1 float-left">
                  <div class="avatar-small">
                    <app-profile-image classInput="avatar-square-small" [displayName]="activity.contact.name"
                      [imageFilePath]="activity.contact.profilePhotoUrl">
                    </app-profile-image>
                  </div>
                </div>&nbsp;
                <div>
                  <small class="text-muted">{{ activity.contact.name }}</small>
                </div>
              </div>
            </a>
            }
          </div>
        </div>
        }
        <!-- <div class="p-3" *ngFor="let activity of recentActivities; trackBy:trackById">
          <div class="message" [ngClass]="{'new-rows': (activity && activity.isRealTime)}">
            <div class="py-3 pb-5 mr-3 float-left">
              <div class="avatar">
                <app-profile-image *ngIf="activity.user" classInput="avatar-square"
                [imageFilePath]="activity.user.profilePictureUrl"></app-profile-image>
                <span class="avatar-status badge-success"></span>
              </div>
            </div>
            <div>
              <small class="text-muted">{{activity.activityType | formatEnum}}</small>
              <small *ngIf="activity.createdAt" class="text-muted float-right mt-1">{{activity.createdAt | formatDate
              }}</small>
            </div>
            <small class="text-muted">{{activity.body}}</small>
          </div>
          <hr>
          </div> -->
      </tab>
      @if (activeAccount && activeAccount.authorizationLevel != 'MEMBER') {
      <tab (selectTab)="onSelect('unassigned')">
        <ng-template tabHeading>
          <div class="avatar2">
            <i class="bi bi-clock"></i>
            @if (newPendingAssignmentCount > 0) {
            <span class="avatar-status2 g-bg-secondary"></span>
            }
          </div>
        </ng-template>
        <div class="comment-box" style="margin-bottom: 0px !important;"> Pending Assignments </div>
        <div
          class="list-group-item list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small">
          Unassigned Leads</div>
        @if (unassignedLeads.length > 0) {
        <div style="padding-left: 0px;">
          <perfect-scrollbar style="max-height: 50vh;" class="ps-show-always" fxFlex="auto">
            <ul class="list-unstyled">
              @for (lead of unassignedLeads; track lead) {
              <li class="d-flex justify-content-start g-brd-around g-brd-gray-light-v4 p-2">
                <!-- <div class="g-pos-rel g-mr-5">
                        <app-profile-image classInput="g-width-30 g-height-30 rounded-circle" [displayName]="lead.name"
                        [imageFilePath]="lead.profilePhotoUrl"></app-profile-image>
                      </div> -->
                <div class="align-self-center g-px-10">
                  <a [routerLink]="['/leads/lead-detail', lead.id]">
                    <h5 class="h6 g-font-weight-600 g-color-black g-mb-3">
                      <span class="g-mr-5">{{lead.name | titlecase}}</span>
                      <small class="g-color-blue">{{lead.contactType | formatEnum}}</small>
                    </h5>
                  </a>
                  <small class="m-0">@if (lead.designation) {
                    <span>Designation :
                      {{lead.designation}} </span>
                    }
                    @if (lead.accountPriority) {
                    <span>&nbsp;Priority:
                      {{lead.accountPriority | formatEnum}} </span>
                    }
                    @if (lead.contactSource) {
                    <span>&nbsp;Source:
                      {{lead.contactSource}} </span>
                    }
                    @if (lead.contactNumberDetail && lead.contactNumberDetail.length > 0) {
                    <span>
                      Number :
                      {{lead.contactNumberDetail[0].phoneNumber}}</span>
                    }
                  </small>
                </div>
                <div class="align-self-center ml-auto">
                  <small>{{lead.createdAt | formatDate}}</small>
                </div>
              </li>
              }
            </ul>
          </perfect-scrollbar>
        </div>
        }
        <div
          class="list-group-item list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small">
          Unassigned Tasks</div>
        @if (unassignedTasks.length > 0) {
        <div style="padding-left: 0px;">
          <perfect-scrollbar style="max-height: 50vh;" class="ps-show-always" fxFlex="auto">
            <ul class="list-unstyled">
              @for (task of unassignedTasks; track task) {
              <li class="d-flex justify-content-start g-brd-around g-brd-gray-light-v4 p-2">
                <div class="align-self-center g-px-10">
                  <a>
                    <h5 class="h6 g-font-weight-600 g-color-black g-mb-3">
                      <span class="g-mr-5">{{task.taskHeading}}</span>
                      <small class="g-color-blue">{{task.taskActivityType}}</small>
                    </h5>
                  </a>
                  <small class="m-0">{{task.taskInputNote}}
                  </small>
                </div>
                <div class="align-self-center ml-auto">
                  <small>{{task.createdAt | formatDate}}</small>
                </div>
              </li>
              }
            </ul>
          </perfect-scrollbar>
        </div>
        }
      </tab>
    }
  </tabset>
</app-aside>
  }
</div>
@if (isAsideOpen) {
  <!-- <div class="aside-backdrop" (click)="toggleAsideMenu(false)" aria-hidden="true"></div> -->
}

</div>

<!-- Commented out: Speed Dial FAB replaced with AI Assist mini-FAB below -->
<!-- @if (hideFab == false) {
<speed-dial-fab class="speed-dial-container" [ngClass]="[speedDialFabPosition, isAsideOpen ? 'shifted-left' : '']"
  [reverse-column-direction]="speedDialFabPosition===SpeedDialFabPosition.Bottom"
  (fabClick)="onSpeedDialFabClicked($event)" [buttons]="speedDialFabButtons"></speed-dial-fab>
} -->

<!-- Background jobs widget -->
@defer (on idle) {
  <app-background-jobs-widget class="bg-jobs-widget-position"
    [jobs]="backgroundJobs"
    [uploadSummaries]="uploadSummaries"
    (dismissed)="onJobsWidgetDismissed()"
    (downloadExport)="onDownloadExport($event)"
    (viewExports)="onViewExports()"
    (viewBulkUpload)="onViewBulkUpload($event)">
  </app-background-jobs-widget>
}

<!-- Quick inbox deferred until idle to avoid affecting LCP -->
@defer (on idle) {
  <app-quick-inbox class="quick-inbox-position"
    [totalWhatsappNewCount]="totalWhatsappNewCount"
    [totalTeamChatNewCount]="totalTeamChatNewCount"
    [internalChatParticipants]="internalChatParticipants"
    [externalChatParticipants]="externalChatParticipants"
    (dismissed$)="onQuickInboxDismissed($event)"
    (refreshRequested)="onQuickInboxRefresh()">
  </app-quick-inbox>
}

<!-- Count of calls sent for transcription; sits above the quick inbox. Renders nothing until a call is requested. -->
@defer (on idle) {
  <app-manual-transcription-snack></app-manual-transcription-snack>
}
<!-- <app-footer>
<span><a href="https://superfone.ai">Superfone</a> &copy; 2021 Evdusk Datatech Private Limited</span>
</app-footer> -->

<audio id="alert-sound">
  <source src="../../../assets/audio/web_whatsapp.mp3" type="audio/mpeg">
</audio>

<!-- AI Assist Module Components - deferred to reduce initial render blocking -->
<!-- Unified Command Palette (Ctrl+K or AI FAB) -->
@if (!meetMode) {
  @defer (on idle) {
    <ai-unified-command-palette></ai-unified-command-palette>
    <ai-spotlight-overlay></ai-spotlight-overlay>
  }
}

<!-- AI Assist Extended FAB -->
@if (hideFab == false && (!sampleDataModeEnabled || shouldShowTrialActivationCard)) {
  @if (shouldShowTrialActivationCard) {
    @if (trialActivationCardMinimized) {
      <div
        class="trial-activation-pill speed-dial-container"
        [ngClass]="[speedDialFabPosition, isAsideOpen ? 'shifted-left' : '']"
        [class.is-unlocked]="trialReward.unlocked"
        [class.is-hidden-by-grid-scroll]="hideAiAssistFabOnGridScroll"
        guideable="trial-progress-assist"
        aria-label="Trial setup progress">
        <button
          type="button"
          class="trial-activation-pill__progress"
          (click)="setTrialActivationCardMinimized(false, $event)"
          title="Show trial setup">
          <mat-icon aria-hidden="true">{{ trialReward.unlocked ? 'workspace_premium' : 'redeem' }}</mat-icon>
          <span>{{ trialReward.unlocked ? 'Free seat unlocked' : 'Trial reward' }}</span>
          <strong [class.trial-activation-pill__count--done]="trialActivationCompletedSteps > 0">{{ trialActivationCompletedSteps }}/{{ trialActivationSteps.length }}</strong>
          @if (trialCountdown; as countdown) {
            <span class="trial-activation-pill__time" [ngClass]="'trial-activation-pill__time--' + countdown.urgency">{{ countdown.days }}d {{ countdown.hours }}h left</span>
          }
          <span class="trial-activation-pill__calls">{{ trialRewardCallCountReady ? trialReward.callCount : '—' }}/{{ requiredTrialTrackedCalls }}</span>
        </button>
        <button
          type="button"
          class="trial-activation-pill__assist"
          (click)="openTrialAssist($event)"
          title="Open Assist (Ctrl+K)"
          aria-label="Open Assist">
          <mat-icon aria-hidden="true">auto_awesome</mat-icon>
        </button>
      </div>
    } @else {
      <aside
        class="trial-activation-card speed-dial-container"
        [ngClass]="[speedDialFabPosition, isAsideOpen ? 'shifted-left' : '']"
        [class.is-unlocked]="trialReward.unlocked"
        [class.is-hidden-by-grid-scroll]="hideAiAssistFabOnGridScroll"
        guideable="trial-progress-assist"
        aria-label="Trial setup progress">
        <header class="trial-activation-card__header">
          <div class="trial-activation-card__brand">
            <span class="trial-activation-card__brand-icon" aria-hidden="true">
              <mat-icon>{{ trialReward.unlocked ? 'workspace_premium' : 'redeem' }}</mat-icon>
            </span>
            <span>{{ trialReward.unlocked ? 'Free admin seat unlocked' : 'Free admin seat challenge' }}</span>
          </div>
          <div class="trial-activation-card__header-actions">
            <span>{{ trialActivationCompletedSteps }} of {{ trialActivationSteps.length }}</span>
            <button
              type="button"
              (click)="setTrialActivationCardMinimized(true, $event)"
              title="Minimize trial setup"
              aria-label="Minimize trial setup">
              <mat-icon aria-hidden="true">remove</mat-icon>
            </button>
          </div>
        </header>

        <div
          class="trial-activation-card__progress"
          role="progressbar"
          aria-label="Trial setup progress"
          [attr.aria-valuenow]="trialActivationPercentComplete"
          aria-valuemin="0"
          aria-valuemax="100">
          <span [style.width.%]="trialActivationPercentComplete"></span>
        </div>

        @if (trialCountdown; as countdown) {
          <section class="trial-activation-card__countdown" [ngClass]="'trial-activation-card__countdown--' + countdown.urgency" aria-label="Time remaining in trial">
            <span class="trial-activation-card__countdown-icon" aria-hidden="true">
              <mat-icon>schedule</mat-icon>
            </span>
            <div>
              <div class="trial-activation-card__countdown-value">
                <strong>{{ countdown.days }} {{ countdown.days === 1 ? 'day' : 'days' }}</strong>
                <span>·</span>
                <strong>{{ countdown.hours }} {{ countdown.hours === 1 ? 'hour' : 'hours' }}</strong>
              </div>
              <span class="trial-activation-card__countdown-label">remaining in your trial</span>
              <p>{{ countdown.message }}</p>
            </div>
          </section>
        }

        <div class="trial-activation-card__body">
          <section class="trial-reward-summary" aria-labelledby="trial-reward-title">
            <span class="trial-activation-card__eyebrow">Earned through real usage</span>
            <h2 id="trial-reward-title">One admin seat, free for your first year</h2>
            @if (trialReward.unlocked) {
              <p>You did the work: 3 reps joined, all 3 installed Salesmax, and 500 real calls were tracked.</p>
            } @else {
              <p>Get 3 reps calling through Salesmax before your trial ends. The product proves its value while you earn the seat.</p>
            }

            <div class="trial-reward-call-progress">
              <div class="trial-reward-call-progress__label">
                <strong>{{ trialRewardCallCountReady ? trialReward.callCount : 'Checking' }}</strong>
                <span>/ {{ requiredTrialTrackedCalls }} tracked calls</span>
              </div>
              <div
                class="trial-reward-call-progress__track"
                role="progressbar"
                aria-label="Tracked calls toward free admin seat"
                [attr.aria-valuenow]="trialRewardCallCountReady ? (trialReward.callsComplete ? requiredTrialTrackedCalls : trialReward.callCount) : 0"
                aria-valuemin="0"
                [attr.aria-valuemax]="requiredTrialTrackedCalls">
                <span [style.width.%]="trialReward.callProgressPercent"></span>
              </div>
            </div>
          </section>

          <ul class="trial-reward-requirements" aria-label="Free seat requirements">
            <li [class.is-complete]="trialReward.representativesComplete">
              <span class="trial-reward-requirements__icon" aria-hidden="true"><mat-icon>{{ trialReward.representativesComplete ? 'check' : 'people' }}</mat-icon></span>
              <div><strong>3 sales reps added</strong><span>{{ trialReward.representativeCount }} of {{ requiredTrialRepresentatives }} · admin excluded</span></div>
            </li>
            <li [class.is-complete]="trialReward.installsComplete">
              <span class="trial-reward-requirements__icon" aria-hidden="true"><mat-icon>{{ trialReward.installsComplete ? 'check' : 'smartphone' }}</mat-icon></span>
              <div><strong>Salesmax installed</strong><span>{{ trialReward.installedRepresentativeCount }} of {{ requiredTrialRepresentatives }} phones</span></div>
            </li>
            <li [class.is-complete]="trialReward.callsComplete">
              <span class="trial-reward-requirements__icon" aria-hidden="true"><mat-icon>{{ trialReward.callsComplete ? 'check' : 'call' }}</mat-icon></span>
              <div><strong>{{ requiredTrialTrackedCalls }} rep calls tracked</strong><span>{{ trialRewardCallCountReady ? trialReward.callCount : 'Checking live count' }}</span></div>
            </li>
          </ul>

          @if (trialActivationNextStep; as nextStep) {
            <section class="trial-reward-next-step" aria-label="Next action">
              <span class="trial-activation-card__eyebrow">Your next move</span>
              <div class="trial-activation-card__step">
                <span class="trial-activation-card__step-icon" aria-hidden="true"><mat-icon>{{ nextStep.icon }}</mat-icon></span>
                <div><h2>{{ nextStep.title }}</h2><p>{{ nextStep.description }}</p></div>
              </div>
            </section>

            @if (nextStep.id === 'install-app' || nextStep.id === 'first-call') {
              <section class="trial-app-readiness" aria-label="Real mobile setup status">
                <div class="trial-app-readiness__heading"><strong>Your reps</strong><span>Live status</span></div>

                @if (trialDeviceKey; as deviceKey) {
                  <div class="trial-device-key">
                    <span class="trial-device-key__icon" aria-hidden="true"><mat-icon>dialpad</mat-icon></span>
                    <div class="trial-device-key__copy"><strong>Workspace PIN</strong><span>Use this when signing in on a rep's phone</span></div>
                    <code>{{ deviceKey }}</code>
                    <button type="button" (click)="copyTrialDeviceKey($event)" title="Copy workspace PIN" aria-label="Copy workspace PIN"><mat-icon aria-hidden="true">content_copy</mat-icon></button>
                  </div>
                }

                <div class="trial-rep-readiness-list">
                  @for (rep of trialActivationDisplayReps; track rep.userId) {
                    <article class="trial-rep-readiness">
                      <div class="trial-rep-readiness__topline">
                        <strong>{{ rep.name }}</strong>
                        <span [attr.data-status]="rep.milestone">
                          @switch (rep.milestone) {
                            @case ('first-call') { Calling }
                            @case ('ready') { Ready }
                            @case ('installed') { Needs setup }
                            @default { Invited }
                          }
                        </span>
                      </div>
                      <div class="trial-rep-milestones" aria-label="Setup milestones">
                        <span class="is-complete">Invited</span>
                        <span [class.is-complete]="rep.installed">Installed</span>
                        <span [class.is-complete]="rep.ready">Ready</span>
                        <span [class.is-complete]="rep.firstCall">First call</span>
                      </div>
                      <div class="trial-rep-readiness__meta"><span>Last app check-in: {{ rep.lastCheckInLabel }}</span></div>
                      <p>{{ rep.nextAction }}</p>
                      @if (rep.whatsappUrl; as whatsappUrl) {
                        <a class="trial-rep-readiness__nudge" [href]="whatsappUrl" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                          <mat-icon aria-hidden="true">chat</mat-icon>WhatsApp {{ rep.name.split(' ')[0] || 'rep' }}
                        </a>
                      }
                    </article>
                  }
                </div>

                <button type="button" class="trial-app-readiness__full-status" (click)="openFullTrialAppStatus($event)">
                  Full app status <mat-icon aria-hidden="true">arrow_forward</mat-icon>
                </button>
              </section>
            }
          }

          <p class="trial-reward-eligibility">For self-created trials. Support confirms eligibility and applies the seat when you subscribe.</p>
        </div>

        <footer class="trial-activation-card__footer">
          @if (trialActivationNextStep; as nextStep) {
            <button
              type="button"
              class="trial-activation-card__primary"
              [disabled]="nextStep.id === 'install-app' && trialAppStatusRefreshing"
              (click)="startTrialActivationNextStep($event)">
              {{ nextStep.id === 'install-app' && trialAppStatusRefreshing ? 'Checking...' : nextStep.ctaLabel }}
              <mat-icon aria-hidden="true">{{ nextStep.id === 'install-app' ? 'sync' : 'arrow_forward' }}</mat-icon>
            </button>
          } @else {
            <button type="button" class="trial-activation-card__primary" (click)="openTrialDashboard($event)">
              View dashboard <mat-icon aria-hidden="true">arrow_forward</mat-icon>
            </button>
          }
          <button type="button" class="trial-activation-card__assist" (click)="openTrialAssist($event)">
            <mat-icon aria-hidden="true">auto_awesome</mat-icon>Open Assist
          </button>
          <button
            type="button"
            class="trial-activation-card__minimize"
            (click)="setTrialActivationCardMinimized(true, $event)"
            title="Minimize trial setup"
            aria-label="Minimize trial setup">
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
        </footer>
      </aside>
    }
  } @else {
    <button
      mat-fab
      extended
      class="ai-assist-mini-fab speed-dial-container"
      [ngClass]="[speedDialFabPosition, isAsideOpen ? 'shifted-left' : '']"
      [class.is-hidden-by-grid-scroll]="hideAiAssistFabOnGridScroll"
      (click)="openUnifiedPalette()"
      title="AI Assist (Ctrl+K)"
      color="primary">
      <mat-icon>auto_awesome</mat-icon>
      Assist
    </button>
  }
}
